import gql from 'graphql-tag'

const GET_QUESTIONS = gql`
  query template($templateName: String!) {
    template(templateName: $templateName) {
      id
      name
      currentQuestionNumber
      currentSubstepTotalNumber
      currentSubstepNumber
      templateStatus
      hasDeliverable
      sections {
        id
        name
        order
        title
        subTitle
      }
      questions {
        id
        order
        maxNumberOfAnswers
        requiredNumberOfAnswers
        subText
        templateId
        sectionId
        text
        hideTrigger
        validationTrigger
        questionType
        validation {
          id
          questionId
          maxAllowedCharacter
          specialFormat
        }
        answers {
          id
          answerType
          answerValue
          groupId
          order
          placeHolder
          questionId
          text
          userSelectedAnswer
        }
      }
    }
  }
`
export default GET_QUESTIONS
